import React, {Component} from "react";
import {Control, Field, Input} from "bloomer";
import SectionName from "../../../../elements/SectionName";
import FieldDescription from "../../../../elements/FieldDescription";
import InputWarning from "../../../../elements/InputWarning";
import {INVALID_FIELD_STYLE} from "../../../../utils/Constants";
import Spacer from "../../../../elements/Spacer";
import WordsLabel from "../../../../elements/WordsLabel";

interface IAirportCodeExtractorState {
    source: string;
    sourceEmpty: boolean;
    showSourceLimitWarning: boolean;
    sourceCharactersCount: number;
    destination: string;
    destinationEmpty: boolean;
    showDestinationLimitWarning: boolean;
    destinationCharactersCount: number;
}

class AirportCodeExtractor extends Component<{}, IAirportCodeExtractorState> {
    public INPUT_CHARACTERS_LIMIT: number = 100;

    public constructor(props: {}) {
        super(props);

        this.state = {
            source: "",
            sourceEmpty: false,
            showSourceLimitWarning: false,
            sourceCharactersCount: 0,
            destination: "",
            destinationEmpty: false,
            showDestinationLimitWarning: false,
            destinationCharactersCount: 0
        };
    }

    public handleSourceChange = (e: any) => {
        const value = e.target.value;
        const charactersCount = value.trim().length;
        this.setState({
            source: value,
            sourceEmpty: false,
            sourceCharactersCount: charactersCount,
            showSourceLimitWarning: charactersCount > this.INPUT_CHARACTERS_LIMIT
        });
    };

    public handleDestinationChange = (e: any) => {
        const value = e.target.value;
        const charactersCount = value.trim().length;
        this.setState({
            destination: value,
            destinationEmpty: false,
            destinationCharactersCount: charactersCount,
            showDestinationLimitWarning: charactersCount > this.INPUT_CHARACTERS_LIMIT
        });
    };

    public resetForm = () => {
        this.setState({
            source: "",
            sourceEmpty: false,
            showSourceLimitWarning: false,
            sourceCharactersCount: 0,
            destination: "",
            destinationEmpty: false,
            showDestinationLimitWarning: false,
            destinationCharactersCount: 0
        });
    };

    public validateForm = () => {
        if (!this.state.source.trim() || this.state.showSourceLimitWarning
        || !this.state.destination.trim() || this.state.showDestinationLimitWarning) {
            if (!this.state.source.trim()) {
                this.setState({
                    sourceEmpty: true
                });
            }

            if (!this.state.destination.trim()) {
                this.setState({
                    destinationEmpty: true
                });
            }

            return false;
        }

        return true;
    };

    public getFormData = () => {
        return {
            source: this.state.source.trim(),
            destination: this.state.destination.trim()
        };
    };

    public render() {
        return <React.Fragment>
            <div style={{marginBottom: "5px"}}>Extracts airport codes from text.</div>
            <FieldDescription>Sample: I want to fly from Los Angeles to Miami.</FieldDescription>
            <Spacer/>
            <Field>
                <Control>
                    <SectionName>Departure:</SectionName>
                    <FieldDescription>Sample: Los Angeles. Maximum size of input is 100 characters.</FieldDescription>
                    <Input
                        style={(this.state.sourceEmpty || this.state.showSourceLimitWarning) ? INVALID_FIELD_STYLE : undefined}
                        onChange={this.handleSourceChange}
                        onPaste={this.handleSourceChange}
                        value={this.state.source}
                        placeholder={"Enter departure location"}
                    />
                    <div>
                        {
                            this.state.sourceEmpty ? <InputWarning>Please input a departure location.</InputWarning> : <></>
                        }
                        {
                            this.state.showSourceLimitWarning ?
                                <InputWarning>Input size limit has been exceeded. Please decrease the size.</InputWarning>
                                : <></>
                        }
                        <WordsLabel>{this.state.sourceCharactersCount}</WordsLabel>
                    </div>
                </Control>
            </Field>
            <Spacer/>
            <Field>
                <Control>
                    <SectionName>Arrival:</SectionName>
                    <FieldDescription>Sample: Miami. Maximum size of input is 100 characters.</FieldDescription>
                    <Input
                        style={(this.state.destinationEmpty || this.state.showDestinationLimitWarning) ? INVALID_FIELD_STYLE : undefined}
                        onChange={this.handleDestinationChange}
                        onPaste={this.handleDestinationChange}
                        value={this.state.destination}
                        placeholder={"Enter arrival location"}
                    />
                    <div>
                        {
                            this.state.destinationEmpty ? <InputWarning>Please input an arrival location.</InputWarning> : <></>
                        }
                        {
                            this.state.showDestinationLimitWarning ?
                                <InputWarning>Input size limit has been exceeded. Please decrease the size.</InputWarning>
                                : <></>
                        }
                        <WordsLabel>{this.state.destinationCharactersCount}</WordsLabel>
                    </div>
                </Control>
            </Field>
            <Spacer/>
        </React.Fragment>;
    }
}

export default AirportCodeExtractor;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/TextCompletion/templates/AirportCodeExtractor.tsx